import { createStore } from 'vuex'

const createSlugMap =
  (typeKey) =>
  ({ beet }) => {
    const data = beet.data[typeKey] || {}
    return Object.values(data).reduce((slugMap, { id, slug }) => ({ ...slugMap, [slug]: id }), {})
  }

export default createStore({
  state: {
    menu: ['business', 'experiences', 'profiles', 'jobs', 'contact'],
  },
  getters: {
    businessesSlugMap: createSlugMap('businesses'),
    jobsSlugMap: createSlugMap('jobs'),
    menu: (state) => state.menu,
  },
  mutations: {},
  actions: {
    async sendForm(_, formData) {
      const response = await fetch(import.meta.env.VITE_APP_API_URL + '/job-application/create', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      })

      const data = await response.json().catch(() => null)

      if (!response.ok) {
        throw data || { message: response.statusText }
      }

      return data
    },
  },
  modules: {},
})
